import * as React from "react";
import * as main from "../../main.module.scss";
import * as grad from "./style.module.scss";
export const Graduate = () => {
  return (
    <section className={grad.graduate}>
      <div className={`container ${grad.container}`}>
        <div className={grad.info}>
          <h2 className={main.title}>Выпускник Advance <span className={main.red}>Анастасия Силина</span></h2>
          <ul>
            <li><strong>Прошла первый, второй и третий модули</strong> в 2017 году</li>
            <li><strong>Выучила 1000 знаков</strong> после запятой в числе Пи, таблицу Менделеева (элементы, порядковый номер, атомная масса), 400 дат, все страны и их столицы</li>
            <li>Изучила и сдала <strong>5 учебников 9 класса за 5 дней</strong></li>
            <li>Разогнала скорость чтения до <strong>800 слов в минуту</strong></li>
          </ul>
          <p>После курсов читаю по 2 книги в неделю, запомнила 10 000 английских слов, зарабатываю 96 000 рублей в месяц, перешла на домашнее обучение. Прошла 9-11 класс академической гимназии СПбГУ за 1 год</p>
        </div>
        <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/graduated.png" alt="Анастасия Силина"/>
      </div>
    </section>
  );
};
